<template>
    <div>
        <div class="row mb-0" style="min-height: 8rem">
            <div class="formdynamic__item col-md-3 py-0">
            <div class="formdynamic__item__field">
                <label for=":" class="modal-label" v-html="'Name'"/>
                <input type="text" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'full_name'})">
            </div>
            </div>
            <div class="col-md-3 ">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label v-html="`Role`" class="modal-label mb-2" :for="`role`" />
                <multiselect
                id="role"
                v-model="form_data.role_id"
                :options="array_options.role_id || []"
                placeholder="Select option(s)"
                label="name"
                track-by="id"
                :multiple="true"
                mode="multiple"
                :close-on-select="false"
                :clear-on-select="false"
                >
                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} role{{
                        values.length > 1 ? "s" : ""
                    }}
                    selected
                    </span>
                </template>
                </multiselect>
            </div>
            </div>

            <div class="col-md-3 ">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label v-html="`Permissions Template`" class="modal-label mb-2" :for="`permissions_template_id`" />
                <multiselect
                id="role"
                v-model="form_data.permissions_template_id"
                :options="array_options.permissions_template_id || []"
                placeholder="Select option(s)"
                label="name"
                track-by="id"
                :multiple="true"
                mode="multiple"
                :close-on-select="false"
                :clear-on-select="false"
                >
                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} permissions template{{
                        values.length > 1 ? "s" : ""
                    }}
                    selected
                    </span>
                </template>
                </multiselect>
            </div>
            </div>

            <div class="col-md-3 ">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label
                v-html="`Reports to`"
                class="modal-label mb-2"
                :for="`reports_to`"
                />
                <multiselect
                id="reports_to"
                v-model="form_data.reports_to"
                :options="array_options.reports_to || []"
                placeholder="Select option(s)"
                label="name"
                track-by="id"
                :multiple="true"
                mode="multiple"
                :close-on-select="false"
                :clear-on-select="false"
                >
                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} associate{{
                        values.length > 1 ? "s" : ""
                    }}
                    selected
                    </span>
                </template>
                </multiselect>
            </div>
            </div>
            <div class="col-md-3 ">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label v-html="`Position`" class="modal-label mb-2" :for="`position`" />
                <multiselect
                id="position"
                v-model="form_data.position_id"
                :options="array_options.position_id || []"
                placeholder="Select option(s)"
                label="name"
                track-by="id"
                :multiple="true"
                mode="multiple"
                :close-on-select="false"
                :clear-on-select="false"
                >
                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} position{{
                        values.length > 1 ? "s" : ""
                    }}
                    selected
                    </span>
                </template>
                </multiselect>
            </div>
            </div>
            <div class="col-md-3 ">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label v-html="`Shift`" class="modal-label mb-2" :for="`shift`" />
                <multiselect
                id="shift"
                v-model="form_data.shift_id"
                :options="array_options.shift_id || []"
                placeholder="Select option(s)"
                label="name"
                track-by="id"
                :multiple="true"
                mode="multiple"
                :close-on-select="false"
                :clear-on-select="false"
                >
                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} shift{{
                        values.length > 1 ? "s" : ""
                    }}
                    selected
                    </span>
                </template>
                </multiselect>
            </div>
            </div>
            <div class="col-md-3 ">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label v-html="`Department`" class="modal-label mb-2" :for="`department`" />
                <multiselect
                id="department"
                v-model="form_data.department_id"
                :options="array_options.department_id || []"
                placeholder="Select option(s)"
                label="name"
                track-by="id"
                :multiple="true"
                mode="multiple"
                :close-on-select="false"
                :clear-on-select="false"
                >
                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} department{{
                        values.length > 1 ? "s" : ""
                    }}
                    selected
                    </span>
                </template>
                </multiselect>
            </div>
            </div>
            <div class="col-md-3 ">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label v-html="`Contact Type`" class="modal-label mb-2" :for="`contact_type`" />
                <multiselect
                id="contact_type"
                v-model="form_data.contact_type_id"
                :options="array_options.contact_type_id || []"
                placeholder="Select option(s)"
                label="name"
                track-by="id"
                :multiple="true"
                mode="multiple"
                :close-on-select="false"
                :clear-on-select="false"
                >
                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} contact type{{
                        values.length > 1 ? "s" : ""
                    }}
                    selected
                    </span>
                </template>
                </multiselect>
            </div>
            </div>
            <div class="col-md-3">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label v-html="`Included in supervisor list?`" class="modal-label mb-2" :for="`include_in_supervisor_lists`" />
                <multiselect 
                    id="status_id"
                    v-model="form_data.include_in_supervisor_lists"
                    :options="array_options.include_in_supervisor_lists || []"
                    placeholder="Select option(s)"
                    label="name"
                    track-by="id"
                    :multiple="true"
                    mode="multiple"
                    :close-on-select="false"
                    :clear-on-select="false">

                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} option{{ values.length > 1  ? 's' : ''}}  selected
                    </span>
                    </template>

                </multiselect>
            </div>
            </div>
            <div class="col-md-3">
            <div class="formdynamic__item__field" id="multiselect__custom">
                <label v-html="`Status`" class="modal-label mb-2" :for="`status_id`" />
                <multiselect 
                    id="status_id"
                    v-model="form_data.status_id"
                    :options="array_options.status_id || []"
                    placeholder="Select option(s)"
                    label="name"
                    track-by="id"
                    :multiple="true"
                    mode="multiple"
                    :close-on-select="false"
                    :clear-on-select="false">

                <template v-slot:selection="{ values }">
                    <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} status{{ values.length > 1  ? 'es' : ''}}  selected
                    </span>
                    </template>

                </multiselect>
            </div>
            </div>
        </div>
        <div class="mt-3 d-flex align-items-center justify-content-center">
            <a style="width: 220px !important;" class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Search'" @click="$emit('resetList', {})"/>
        </div>
    </div>
</template>

<script>
import Multiselect  from    "vue-multiselect"

export default {
  name: "LocalFormSearch",

  components: {
    Multiselect,
  },

  props: [
    "array_options",
    "form_data",
],

  data() 
  {
    return {
      
    };
  },

  mounted() 
    {
        window.addEventListener('keydown', this.handleEnterKey);
    },
    beforeDestroy() 
    {
        window.removeEventListener('keydown', this.handleEnterKey);
    },

    methods: {
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.$emit('resetList', {})
      }
    },
  }
};
</script>